// extracted by mini-css-extract-plugin
export default {"container":"style_container__QnIyW","child":"style_child__y6TmJ"};